import { ISeasonsApi } from '../types';
import Core from '@mediaplatform/sportal365-football-sdk-v2';

export default (sdk: Core): ISeasonsApi => {
  const getSeasons: ISeasonsApi['getSeasons'] = ({ teamId, signal, competitionId }) => {
    const seasons = sdk.seasons();

    if (!seasons) return;

    if (teamId) {
      seasons.forTeam(teamId);
    }

    if (competitionId) {
      seasons.forCompetition(competitionId);
    }

    return seasons.get({ signal });
  };

  return { getSeasons };
};
